import { allowedValuesRule, type WorksheetRules } from '../as400CellRuleKinds';

/**
 * The Stock worksheet's own rules, on top of its columns' character limits and
 * header masks (the pick-front quantities are 99999.99). Append new entries;
 * keep one ticket's entries together under its comment.
 */
export const STOCK_SHEET_RULES: WorksheetRules = {
  rules: [
    // The workbook's cell notes: each flag's valid values. Blank leaves the
    // field alone, as on every other worksheet's flags.
    allowedValuesRule('STK_DMI', ['Y', 'N'], { blankAllowed: true }),
    allowedValuesRule('STK_OVERSTOCK_CONTROLLED', ['Y', 'N'], {
      blankAllowed: true,
    }),
    allowedValuesRule('STK_PRIMARY_LOCATION', ['Y', 'N', 'D'], {
      blankAllowed: true,
    }),
    allowedValuesRule('STK_CHG_MAX_PICK_FRONT', ['Y', 'N'], {
      blankAllowed: true,
    }),
    allowedValuesRule('STK_CHG_CURRENT_PICK_FRONT', ['Y', 'N'], {
      blankAllowed: true,
    }),
  ],
  autoFills: [],
  addDefaults: [],
};
